import { declareParams, JsonApiRequestError } from '@farfetched/core';
import { zodContract } from '@farfetched/zod';
import { createStore, Store } from 'effector';
import { RegistryParams, RegistryQuery } from 'shared/lib';
import { createAuthQuery } from '../auth-http-client';
import { createPaginatedSchema, Game, gameSchema } from '../types';

export type OriginalGameRegistryParams = {
	sortField?: string | null;
	sortDirection?: string;
	page?: number;
	limit?: number;
	accountIds?: string[];
	accountId?: string[];
	gameIds?: string[];
};

export type GameRegistryFilters = {
	gameIds: number[];
	accountIds: number[];
};

export type GameRegistryParams = RegistryParams<GameRegistryFilters>;

export type GamesRegistryQuery = RegistryQuery<Game, GameRegistryFilters, JsonApiRequestError>;

export const createGameRegistryQuery = ($accountId?: Store<number | null>): GamesRegistryQuery =>
	createAuthQuery({
		params: declareParams<GameRegistryParams>(),
		request: {
			method: 'GET',
			url: '/games/list',
			query: {
				source: $accountId ?? createStore<number | null>(null),
				fn: (params, accountId) => ({
					page: params.page,
					limit: params.limit,
					sortField: params.sortField ?? undefined,
					sortDirection: params.sortDirection,
					accountIds: [
						...(accountId ? [String(accountId)] : []),
						...params.filters.accountIds.map(String),
					],
					gameIds: params.filters.gameIds.map(String),
				}),
			},
		},
		response: {
			contract: zodContract(createPaginatedSchema(gameSchema)),
		},
	});
